import React from 'react';

import { Formik, Form, FormikValues } from 'formik';
import * as yup from 'yup';

import Field from 'components/Field';
import Input from 'components/Input';
import InputSecret from 'components/InputSecret';
import Header from 'components/LogoHeader';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { Container, AcceptButton, Body, GroupButton, TextHeader } from './styles';

export interface Props {
  loading: boolean;
  onLogin: (email: string, password: string) => void;
}

const LoginEmail = ({ loading, onLogin }: Props) => {
  const { t } = useStoreTranslation();

  const handleSubmit = (data: { email: string; password: string }) => {
    onLogin(data.email, data.password);
  };

  const validationSchema = yup.object().shape({
    email: yup.string().email().required(),
    password: yup.string().required(),
  });

  const initialValues = {
    email: '',
    password: '',
  };

  return (
    <Container>
      <Formik
        initialStatus={{ rightCheckIfIsValid: true }}
        initialValues={initialValues}
        isInitialValid={(formik: any) => validationSchema.isValidSync(formik.initialValues)}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isValid }: FormikValues) => (
          <Form>
            <Header />
            <Body>
              <TextHeader>
                <h3>{t('loginEmail.welcome')}</h3>
              </TextHeader>
              <Field name="email" labelKey="loginEmail.email">
                <Input
                  id="email"
                  type="email"
                  placeholder={t('loginEmail.emailPlaceholder')}
                  autoCapitalize="off"
                  autoCorrect="off"
                />
              </Field>
              <Field name="password" labelKey="loginEmail.password">
                <InputSecret id="password" placeholder={t('loginEmail.passwordPlaceholder')} />
              </Field>
              <GroupButton>
                <AcceptButton disabled={!isValid || loading} value={t('loginEmail.loginButton')} loading={loading} />
              </GroupButton>
            </Body>
          </Form>
        )}
      </Formik>
    </Container>
  );
};

export default LoginEmail;
